export default function RiskIntroStep() {
  return (
    <div>
      <h2
        style={{
          fontSize: 20,
          fontWeight: 700,
          color: 'var(--fg)',
          marginBottom: 12,
          fontFamily: 'var(--font-display)',
        }}
      >
        Let's start with what could go wrong
      </h2>
      <p style={{ fontSize: 14, color: 'var(--fg2)', lineHeight: 1.75, marginBottom: 0 }}>
        Think about how people join your organisation. Do you always do reference checks before
        someone starts? Is system access always limited to what their role actually needs? This is
        what compliance calls a risk: something that might not happen the way it should, and could
        cause a problem if it doesn't. Let's capture that as a risk in Tryggr.
      </p>
    </div>
  );
}
